import { ILinkPreviewModel } from '@gem/models/commonModel';

import { messageModel } from 'APP/model/model';

export async function getLinkPreview(link: string): Promise<ILinkPreviewModel | null> {
  try {
    return await messageModel.getLinkPreview(link);
  } catch (error) {
    return null;
  }
}
